<template>
  <footer class="site-footer">

    <div class="footer-content">
      <div class="left">
          <img src="/images/logo-dark.png" alt="St Lukes Church" class="logo">

          <div class="social">
            <a :href="footer_data.facebook" target="_blank">
              <img src="/images/facebook.svg" alt="St Lukes Facebook"> Follow us on Facebook
            </a>
          </div>

          <ul class="navs">
            <li
              v-for="(link, index) of menu"
              :key="index"
            >
              <a :href="link.url">{{ link.title }}</a>
            </li>
          </ul>
      </div>
      <div class="right">
        <h3 class="h1">Contact Us</h3>

        <a :href="footer_data.email_url" class="email" target="_blank">{{ footer_data.email }}</a>
        <p v-html="footer_data.footer_contact"></p>

        <a :href="contact_page.url" class="button">Click here</a>
      </div>
    </div>

    <div class="footer-legal">
      <p class="copyright">
        &copy; 2021 St Luke's Church.
        <a
          href="http://www.brownpaperbag.co.nz/"
          target="_blank"
        >
           Web Design by { brownpaperbag }
        </a>
      </p>
    </div>

  </footer>
</template>

<script>
export default {
  props: [
		'menu',
    'footer_data',
    'contact_page'
	],
};
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue